import { ExcalidrawElement } from "@excalidraw/excalidraw/types/element/types";
import {
  AppState,
  BinaryFiles,
  Collaborator,
} from "@excalidraw/excalidraw/types/types";
import { Socket } from "socket.io-client";

export interface IPointerData {
  pointer: Collaborator["pointer"];
  button: Collaborator["button"];
  selectedElementIds: Collaborator["selectedElementIds"];
}

export interface IWhiteboardProps {
  initialData: {
    elements: readonly ExcalidrawElement[] | undefined;
    files: BinaryFiles | undefined;
  };
  questionSlug: string;
  collab?: {
    enabled: boolean;
    useCollaborators?: (key: string) => AppState["collaborators"];
    batching?: {
      enabled: boolean;
      drawingDataDelay: number;
      pointerDataDelay: number;
    };
    socket: Socket;
  };
  onChangeData: (
    elements: readonly ExcalidrawElement[],
    files: BinaryFiles,
  ) => void;
}

export const PRECEDING_ELEMENT_KEY = "__precedingElement__";

export type BroadcastedExcalidrawElement = ExcalidrawElement & {
  [PRECEDING_ELEMENT_KEY]?: string;
};
